@if(valueAddedTaxEntity$ | async) {
  <form [formGroup]="icpOpgaafFg">
    <div class="row">
      <ng-container formArrayName="opgaves">
          @for (item of opgaves.controls; track item; let i = $index) {
          <ng-container [formGroup]="item">
            @if (i === index) {
              @let icpControls = getIcp(i).controls;
              <div formArrayName="icps">
                  @for (item1 of icpControls; track item1; let k = $index) {
                  <div [formGroup]="item1">
                    <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
                      <!-- Soort prestatie -->
                      <snelstart-ui-select-form-control
                        (change)="saveForm()"
                        [label]="k === 0 ? 'Soort prestatie' : ''"
                        [options]="optionsICP"
                        [required]="true"
                        class="custom-input-250"
                        formControlName="soort"
                        id="soort">
                      </snelstart-ui-select-form-control>

                      <snelstart-ui-select-form-control
                        (change)="saveForm()"
                        [label]="k === 0 ? 'Landcode' : ''"
                        [options]="optionsLanden"
                        [required]="true"
                        class="custom-input-150"
                        formControlName="landcode"
                        id="landcode">
                      </snelstart-ui-select-form-control>

                      <snelstart-ui-text-form-control
                        (change)="saveForm()"
                        [label]="k === 0 ? 'Identificatie nummer' : ''"
                        [required]="true"
                        class="custom-input-150"
                        formControlName="nationaalBtwIdNummer"
                        id="nationaalBtwIdNummer">
                      </snelstart-ui-text-form-control>

                      <snelstart-ui-number-form-control
                        (change)="saveForm();"
                        [label]="k === 0 ? 'Bedrag' : ''"
                        [required]="true"
                        [showAllDecimals]="false"
                        align="right"
                        class="custom-input-150"
                        formControlName="bedrag"
                        id="bedrag"
                        prefix="€">
                      </snelstart-ui-number-form-control>

                      <!--                <ng-container *ngIf="!getIcp(i).controls.at(k)?.get('soort')?.getRawValue()?.includes('CORRECTIE')">-->
                      <!--                  <div class="col-auto">-->
                      <!--                    <snelstart-ui-button-->
                      <!--                      (click)="this.validateNumber(item1.getRawValue())"-->
                      <!--                      [class]="k === 0 ? 'firstrowbutton' : ''"-->
                      <!--                      icon="cloud-check"-->
                      <!--                      iconType="light"-->
                      <!--                      id="buttoncheck"-->
                      <!--                      type="secondary">-->
                      <!--                      Check identificatienummer-->
                      <!--                    </snelstart-ui-button>-->
                      <!--                  </div>-->
                      <!--                </ng-container>-->

                      <!-- Tijdvak Correctie (conditionally shown) -->
                      @if (icpControls.at(k)?.get('soort')?.getRawValue()?.includes('CORRECTIE')) {
                        <ng-container formGroupName="tijdvakCorrectie">
                          <div class="col-auto">
                            <snelstart-ui-date-form-control
                              (change)="saveForm();"
                              [label]="k === 0 ? 'Aanvang tijdvak' : ''"
                              [required]="true"
                              class="custom-input-150"
                              formControlName="begindatum"
                              id="begindatum">
                            </snelstart-ui-date-form-control>
                          </div>
                          <div class="col-auto">
                            <snelstart-ui-date-form-control
                              (change)="saveForm();"
                              [label]="k === 0 ? 'Einde tijdvak' : ''"
                              [required]="true"
                              class="custom-input-150"
                              formControlName="einddatum"
                              id="einddatum">
                            </snelstart-ui-date-form-control>
                          </div>
                        </ng-container>
                      }

                      <!-- 🗑️ Delete button -->
                      <div class="col-auto ">
                        <snelstart-ui-button
                          (click)="deleteIcp(i, k)"
                          [class]="k === 0 ? 'firstrowbutton' : ''"
                          icon="trash"
                          iconType="light"
                          id="buttonDelete"
                          size="medium"
                          type="secondary">
                        </snelstart-ui-button>
                      </div>
                    </div>
                  </div>
                }
                <div>
                  <snelstart-ui-button (click)="addIcp(i)"
                                       class="snelstart-ui-button pb-3"
                                       icon="plus"
                                       type="link">ICP toevoegen
                  </snelstart-ui-button>
                </div>
              </div>
            }
          </ng-container>
        }
      </ng-container>
    </div>
  </form>
}
